<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="form">
  <p-calendar
    [timeOnly]="true"
    formControlName="time_fake"
    inputStyleClass="form-control"
    class="prime-ng-datapicker"
    styleClass="d-block"
    baseZIndex="1"
    (onSelect)="onSelect()"
    (onInput)="onType()"
    [firstDayOfWeek]="1"
  >
  </p-calendar>
</div>
